import { createSlice } from "@reduxjs/toolkit";
import {
  fetchMulesoftEndpoints,
  deleteMulesoftEndpoint,
  fetchMulesoftSwaggerData,
  fetchMuleIntegrations,
  createIntegration,
  deleteMuleIntegration,
  updateIntegrationDetails,
  fetchIntegration,
} from "./mulesoft.actions";
import { deleteService } from "../DataModels";
import { EMPTY_STRING } from "../../constants";

const searchFilter = {
  name: EMPTY_STRING,
};

const initialState = {
  mulesoftEndpoints: [],
  mulesoftServices: [],
  swaggerData: null,
  mulesoftDeployStatus: null,
  selectedMulesoftEndpoint: null,
  integrations: {
    data: [],
  },
  mulesoftIntegrationsFilters: searchFilter,
  selectedIntegration: null,
  selectedIntegrationId: null,
};

const slice = createSlice({
  name: "mulesoftEndpoints",
  initialState,
  reducers: {
    setMulesoftDeployStatus(state, action) {
      state.mulesoftDeployStatus = action.payload;
    },
    setSelectedMulesoftEndpoint(state, action) {
      state.selectedMulesoftEndpoint = action.payload;
    },
    setSelectedIntegration(state, action) {
      state.selectedIntegration = action.payload;
    },
    setSelectedIntegrationId(state, action) {
      state.selectedIntegrationId = action.payload;
    },
    setMulesoftSwaggerData(state, action) {
      state.swaggerData = action.payload;
    },
    setMuleIntegrationsFilters(state, action) {
      state.mulesoftIntegrationsFilters = action.payload || searchFilter;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMulesoftEndpoints.fulfilled, (state, action) => {
        state.mulesoftEndpoints = action.payload.endpoints;
        state.mulesoftServices = action.payload.services;
      })
      .addCase(deleteMulesoftEndpoint.fulfilled, (state, action) => {
        if (!action.payload) return;
        state.mulesoftEndpoints = state.mulesoftEndpoints.filter(
          (item) => item.id !== action.payload.id
        );
      })
      .addCase(fetchMulesoftSwaggerData.fulfilled, (state, action) => {
        if (!action.payload) return;
        state.swaggerData = action.payload;
      })
      .addCase(deleteService.fulfilled, (state, action) => {
        if (!action.payload) return;
        state.mulesoftServices = state.mulesoftServices.filter(
          (item) => item.id !== action.payload.id
        );
      })
      .addCase(fetchMuleIntegrations.fulfilled, (state, action) => {
        if (!action.payload) return;
        state.integrations = action.payload;
      })
      .addCase(createIntegration.fulfilled, (state, action) => {
        if (!action.payload) return;
        state.integrations = {
          ...state.integrations,
          data: [...state.integrations.data, action.payload],
          total: state.integrations.total + 1,
        };
      })
      .addCase(deleteMuleIntegration.fulfilled, (state, action) => {
        if (!action.payload) return;
        const updatedIntegrations = state.integrations.data.filter(
          (integration) => integration.id !== action.payload.id
        );
        state.integrations = {
          ...state.integrations,
          data: updatedIntegrations,
          total: state.integrations.total - 1,
        };
      })
      .addCase(fetchIntegration.fulfilled, (state, action) => {
        if (!action.payload) return;
        state.selectedIntegration = action.payload;
      })
      .addCase(updateIntegrationDetails.fulfilled, (state, action) => {
        if (!action.payload) return;
        const updatedIntegrations = state.integrations.data.map((integration) =>
          integration.id === action.payload.id
            ? { ...integration, ...action.payload }
            : integration
        );
        state.integrations = {
          ...state.integrations,
          data: updatedIntegrations,
        };
        state.selectedIntegration = null;
      });
  },
});

export default slice;

export const { name, actions, reducer } = slice;
